import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TEXT_CONSTANTS } from '../../constants/text-constants';

/**
 * Shows a dismissable banner prompting iOS Safari users
 * to add the app to their home screen for a native-like experience.
 */
@Component({
    selector: 'ios-install-prompt',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ios-install-prompt.component.html',
    styleUrl: './ios-install-prompt.component.css'
})
export class IosInstallPromptComponent implements OnInit {
    TEXT = TEXT_CONSTANTS;
    showPrompt = false;

    private readonly STORAGE_KEY = 'fina_ios_install_dismissed';

    ngOnInit(): void {
        this.showPrompt = this.shouldShowPrompt();
    }

    /** Determines if the prompt should be shown based on platform and dismissal state. */
    private shouldShowPrompt(): boolean {
        // 1. Already dismissed?
        if (localStorage.getItem(this.STORAGE_KEY) === 'true') {
            return false;
        }

        // 2. Already running as standalone PWA?
        if ((navigator as any).standalone === true) {
            return false;
        }

        // 3. Match media for standalone (Chrome/Android PWA check)
        if (window.matchMedia('(display-mode: standalone)').matches) {
            return false;
        }

        // 4. Is it iOS Safari?
        const ua = navigator.userAgent;
        const isIos = /iPhone|iPad|iPod/.test(ua);
        const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);

        return isIos && isSafari;
    }

    /** Dismisses the prompt and stores the preference. */
    dismiss(): void {
        this.showPrompt = false;
        localStorage.setItem(this.STORAGE_KEY, 'true');
    }
}
